import ResetPasswordFieldControl from 'global/resetPassword/ResetPasswordFieldControl';

const { FormControl } = window.od;

class ResetPasswordFormControl extends FormControl {
	initFieldControl(field) {
		const rules = this.rules[field.name];
		return new ResetPasswordFieldControl(field, rules);
	}
}

export default ResetPasswordFormControl;
